import { render, staticRenderFns } from "./formViewer.vue?vue&type=template&id=05ffdb5d&"
import script from "./formViewer.vue?vue&type=script&lang=js&"
export * from "./formViewer.vue?vue&type=script&lang=js&"
import style0 from "./formViewer.vue?vue&type=style&index=0&id=05ffdb5d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports